export default __webpack_public_path__ + "static/media/notification.bcee811b.svg";